export default __webpack_public_path__ + "static/media/grid-1.61e1c1a3.svg";